import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';

import { neutral500 } from '@fever/ui';

export default function PageForbidden() {
    return (
        <div css={style}>
            <Typography variant="h1">403 Forbidden</Typography>
        </div>
    );
}

const style = css`
    color: ${neutral500};
    height: 100%;
    text-align: center;
    > * {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
`;
